import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { profileData } from '../mock';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <img
          src={profileData.heroImage}
          alt="Professional background"
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-text">{profileData.yearsExperience}+ Years of Excellence</span>
          </div>

          <h1 className="hero-title">{profileData.companyName}</h1>
          <p className="hero-subtitle">{profileData.name} - {profileData.title}</p>
          <p className="hero-tagline">{profileData.tagline}</p>

          <div className="hero-cta">
            <Button onClick={() => window.location.href = '#contact'} className="primary-cta">
              Schedule Consultation <ArrowRight className="cta-icon" size={20} />
            </Button>
            <Button onClick={() => window.location.href = '#case-studies'} className="secondary-cta">
              View Case Studies
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
